<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="오늘 전화 연결 내역"
      desc="파트너에게 전화연결을 시도한 전체 내역입니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="call_detail" slot-scope="props">
        <button class="button"
                v-if="!props.item.call"
                @click.stop.prevent="clickCall(props.item,'create')">상세 등록</button>
        <button class="button is-font"
                v-if="props.item.call"
                @click.stop.prevent="clickCall(props.item,'update')">상세 보기</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import moment from 'moment'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpModal from '../../module/common/LpModal.vue'


  export default {

    mixins: [
      ListMixin
    ],

    components: {
      LpSortDropDown, LpInputText, LpRadio,
      LpModal
    },
    created() {
      this.init();

    },
    data () {
      return {
        test:'',
        nowTime: '',
        nowOpened: '',
        searchType: [
          { label: '전체', value: 'all' },
          { label: '이름', value: 'name' },
          { label: '상담내용', value: 'content' },
          { label: '연락처', value: 'phone' },
        ],
        memberArr: [
          { label: '전체', value: '' },
          { label: '회원', value: 'false' },
          { label: '비회원', value: 'true' }
        ],
        /* // 필터링 데이터
         filtered: {
           date: {
             min: '',
             max: ''
           },
           memberState: '전체',
           reserveState: '전체',
           state: 'all',
           search_type: 'all',
           search_keyword: '',
           page_num: 1,
           page_length: 10,
           // order_field: {
           //   value: 'asc',
           //   item: 'ests'
           // }
         },*/
        filtered: {
          min_price:"",
          max_price:"",
          start: "",
          end: "",
          cat1: "",
          cat2: "",
          cat3: "",
          sido: "",
          sigungu: "",
          dong: "",
          ordering: "",
          is_guest: "",
          search_type: 'all',
          search_keyword: '',
          page_num: 1,
          page_length: 10
        },
        tableItems:[],
        allCount: 0,
        filteredCount: 0,
        pageCount: 0,
        pageLengthList : [
          {
            label: '5개씩 보기',
            value: 5
          },
          {
            label: '10개씩 보기',
            value: 10
          },
          {
            label: '20개씩 보기',
            value: 20
          },
          {
            label: '30개씩 보기',
            value: 30
          }
        ],
        modalCall: 0
      }
    },
    methods: {
      init () {
        this.test = new Date().getTime()
        this.initializing('call_new', 'product/call');
        this.filtered.start =  moment().format('YYYY-MM-DD');
      },
      getDataFromServer() {
        this.getData();
      },
      selectMemberState(state) {
        this.filtered.memberState = state;
      },
      clickCall(item) {
        // 전화 상담/주문 call 있을경우
        if( item.call ) {
          // 회원일 경우
          if ( item.user_id ){
            this.$router.push(this.getPath('cs/call/create?id=' + item.call + '&user_id=' + item.user_id + '&types=call'));
          }
          // 비회원
          else {
            this.$router.push(this.getPath('cs/call/create?id=' + item.call + '&types=call'));
          }
        }
        // 새로 등록할 경우
        else {
          // 회원일 경우
          if ( item.user_id ){
            this.$router.push(this.getPath('cs/call/create?user_id=' + item.user_id + '&product_call_id=' + item.id + '&types=call'));
          }
          // 비회원
          else {
            this.$router.push(this.getPath('cs/call/create?product_call_id=' + item.id + '&types=call'));
          }
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" sc
       oped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .tr-whole-border th
    padding 12px 6px
  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem
  .btn-confirm-new-req
    background-color #ffb100
    color #fff
  .btn-stand-by-ests
    color #064160
    font-weight bold
  .btn-write-sheet
    background-color $primary
    color #fff

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e
</style>
